module.exports = __webpack_public_path__ + "img/CZ49241257.3367c782.jpeg";